<div class="page-container">
  <div class="page-heading">
    <h3>
      <img class="nav-icon" src="assets/icons/list_alt_black_24dp.svg">
      <span class="page-title">{{'planner.projectPage.projectSettings' | translate }}</span>
    </h3>
  </div>
  <div class="page-content">
    <div class="card">
      <div class="card-body">
        <div id="project-basic-information">
          <div class="row">
            <div class="col-md-12">
              <div>
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <h4>{{'planner.projectPage.basicInfo' | translate }}</h4>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <button class="btn btn-secondary float-end" (click)="showProjectInfo = !showProjectInfo"><img src="assets/icons/edit_gray_24dp.svg" class="btn-icon">{{'basic.edit' | translate }}</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label>{{'basic.name' | translate }}</label>
                    <div>{{ projectName }}</div>
                    <load-spinner [hidden]="projectName"></load-spinner>
                  </div>
                  <div class="form-group">
                    <label>{{'basic.installTime' | translate }}</label>
                    <div>{{ calculatedTime }}</div>
                    <load-spinner [hidden]="calculatedTime"></load-spinner>
                  </div>

                </div>
                <div class="col-4">
                  <div class="form-group">
                    @if (!importedLoading) {
                      <div>
                        <label>
                          @if (customerId === 2) {
                            <span>Strings</span>
                          }
                          @if (customerId !== 2) {
                            <span>{{'planner.projectDashboard.frame' | translate}}</span>
                          }
                        </label>
                        <div>{{ workorderCount }}</div>
                      </div>
                    }
                    @if (importedLoading) {
                      <load-spinner></load-spinner>
                    }
                  </div>
                  <div class="form-group">
                    @if (!this.inverterLoader) {
                      <div>
                        <label>{{'planner.projectDashboard.inverter' | translate}}</label>
                        <div>{{invertersCount}}</div>
                      </div>
                    }
                    @if (this.inverterLoader) {
                      <load-spinner></load-spinner>
                    }
                  </div>
                  @if (customerId === 3) {
                    <div class="form-group">
                      <div [hidden]="this.powerlineLoader">
                        <label>Powerlines</label>
                        <div>{{powerlinesCount}}</div>
                      </div>
                      <load-spinner [hidden]="!this.powerlineLoader"></load-spinner>
                    </div>
                  }

                </div>
                <div class="form-group col-4">
                  <label>{{'basic.info' | translate }}</label>
                  <div [hidden]="showProjectInfo">{{projectInfo}}</div>
                  <textarea class="mb-3 w-100" cols="30" rows="6" [(ngModel)]="projectInfo" [hidden]="!showProjectInfo" style="resize: none;"></textarea>
                  <button type="button" class="btn btn-primary left" [hidden]="!showProjectInfo" (click)="saveInfo()" data-bs-dismiss="modal">{{'basic.save' | translate}}</button>
                  <button type="button" class="btn btn-secondary ml-1" [hidden]="!showProjectInfo" (click)="showProjectInfo = !showProjectInfo"> {{'basic.cancel' | translate }}</button>

                </div>
              </div>
            </div>
          </div>
        </div>

        <hr> <!-- Divider -->

        @if (!myParam) {
          <div>
            <div class="row">
              <!-- Project default time estimates begin -->
              <div class="col-md-6 text-capitalize pb-10">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <h4>{{'planner.projectPage.projectTimeEstimates' | translate }}</h4>
                    </div>
                  </div>
                  <div class="col-md-4" [hidden]="estimatesLoading">
                    <button [hidden]="timeEditor" [disabled]="!projectTimeEstimates" id="timeEditBtn" class="btn btn-secondary ml-10 float-end" (click)="enableTimeEditor()"><img src="assets/icons/edit_gray_24dp.svg" class="btn-icon">{{'basic.edit' | translate }}</button>
                    <div [hidden]="!timeEditor">
                      <button type="button" class="btn btn-primary" form="time-parameters" type="submit"> {{'basic.save' | translate }}</button>
                      <button type="button" class="btn btn-secondary ml-1" (click)="disableTimeEditor()"> {{'basic.cancel' | translate }}</button>
                    </div>
                  </div>
                </div>
                <!-- Powerline time estimates -->
                @if (customerId === 3) {
                  <div [hidden]="timeEditor || estimatesLoading">
                    <div [hidden]="projectTimeEstimates" class="red-text">{{'planner.projectPage.noTimeEstimates' | translate}}</div>
                    <div [hidden]="!projectTimeEstimates">
                      <div class="estimate-holder mt-10">
                        <h4>{{ 'planner.projectPage.powerlines' | translate }}</h4>
                        @if (getByType(projectTimeEstimates, [4]); as sortedEstimates) {
                          @for (item of sortedEstimates; track $index; let i = $index) {
                            <div class="estimates row">
                              @if (i > 0 && item.type !== sortedEstimates[i - 1].type) {
                                <div>
                                  <hr>
                                  </div>
                                }
                                <div class="col-md-6">
                                  <div>
                                    <span>{{ item.definition }}</span>
                                    <span class="mx-1">-</span>
                                    <span class="blue-text">Powerline</span>
                                  </div>
                                </div>
                                <div class="col-md-4 minutes">
                                  @if (item.state !== 1) {
                                    <div>
                                      {{ item.estimate }} <span>{{'planner.projectPage.minutes' | translate}}</span>
                                    </div>
                                  }
                                </div>
                                <div class="col-md-2">
                                  <div>
                                    <span class="dot" [ngStyle]="{'background-color': item.color, 'border': '1px solid black'}"></span>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div [hidden]="timeEditor || estimatesLoading">
                      <div [hidden]="projectTimeEstimates" class="red-text">{{'planner.projectPage.noTimeEstimates' | translate}}</div>
                      <div [hidden]="!projectTimeEstimates">
                        <div class="estimate-holder mt-10">
                          @if (getByType(projectTimeEstimates, [1, 2, 3]); as sortedEstimates) {
                            @for (item of sortedEstimates; track $index; let i = $index) {
                              <div class="estimates row">
                                @if (i > 0 && item.type !== sortedEstimates[i - 1].type) {
                                  <div>
                                    <hr>
                                    </div>
                                  }
                                  <div class="col-md-6">
                                    <div>
                                      <span>{{ item.definition }}</span>
                                      <span class="mx-1">-</span>
                                      @if (customerId === 2 && item.type === 1) {
                                        <span class="blue-text">String</span>
                                      }
                                      @if (customerId !== 2 && item.type === 1) {
                                        <span class="blue-text">{{'planner.projectDashboard.frame' | translate}}</span>
                                      }
                                      @if (item.type === 2) {
                                        <span class="blue-text">{{'planner.projectDashboard.inverter' | translate}}</span>
                                      }
                                      @if (item.type === 3) {
                                        <span class="blue-text">Checkup</span>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-4 minutes">
                                    @if (item.state !== 1) {
                                      <div>
                                        {{ item.estimate }} <span>{{'planner.projectPage.minutes' | translate}}</span>
                                      </div>
                                    }
                                  </div>
                                  <div class="col-md-2">
                                    <div>
                                      <span class="dot" [ngStyle]="{'background-color': item.color, 'border': '1px solid black'}"></span>
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Display project default time estimates -->
                    <!-- Project default time estimates editor -->
                    <div [hidden]="!timeEditor">
                      <form ngNativeValidate id="time-parameters" class="estimate-holder" #f="ngForm" (ngSubmit)="saveChangesToEstimates(f)">
                        <div class="mt-10">
                          <div class="row">
                            <div class="form-group col-md-6">
                              <label>{{'basic.options' | translate }}</label>
                            </div>
                            <div class="form-group col-md-4">
                              <label>{{'basic.estimates' | translate }}</label>
                            </div>
                            <div class="form-group col-md-2">
                              <label>{{'basic.color' | translate }}</label>
                            </div>
                          </div>
                          @if (sortByType(projectTimeEstimates); as sortedEstimates) {
                            @for (item of sortedEstimates; track $index; let i = $index) {
                              <div class="row">
                                @if (i > 0 && item.type !== sortedEstimates[i - 1].type) {
                                  <div>
                                    <hr>
                                    </div>
                                  }
                                  <div class="col-md-6">
                                    <div class="form-group d-flex align-items-center h-100">
                                      <div>
                                        <span>{{ item.definition }}</span>
                                        <span class="mx-1">-</span>
                                        @if (customerId === 2 && item.type === 1) {
                                          <span class="blue-text">String</span>
                                        }
                                        @if (customerId !== 2 && item.type === 1) {
                                          <span class="blue-text">{{'planner.projectDashboard.frame' | translate}}</span>
                                        }
                                        @if (item.type === 2) {
                                          <span class="blue-text">{{'planner.projectDashboard.inverter' | translate}}</span>
                                        }
                                        @if (item.type === 3) {
                                          <span class="blue-text">Checkup</span>
                                        }
                                        @if (item.type === 4) {
                                          <span class="blue-text">Powerline</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 minutes">
                                    <div class="form-group">
                                      <input
                                        type="number"
                                        [(ngModel)]="item.estimate"
                                        name="{{ 'estimate_'+item.id }}"
                                        class="form-control"
                                        [hidden]="item.state === 1">
                                    </div>
                                  </div>
                                  <div class="col-md-2">
                                    <div class="form-group text-capitalize">
                                      <input type="color" required class="form-control" name="{{ 'color_'+item.id }}" [(ngModel)]="item.color">
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </form>
                      </div>
                      <div [hidden]="!estimatesLoading" class="gray-text mt-10">
                        <load-spinner></load-spinner>
                      </div>
                    </div>
                    <!-- Default group sizes -->
                    <div class="col-md-6 text-capitalize right-container pb-10">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group">
                            <h4>Default group sizes</h4>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <button [hidden]="msaEditor" id="msaTimeEditBtn" class="btn btn-secondary ml-10 float-end" (click)="enableMsaEditor()"><img src="assets/icons/edit_gray_24dp.svg" class="btn-icon">{{'basic.edit' | translate }}</button>
                          <div [hidden]="!msaEditor">
                            <button type="button" class="btn btn-primary" form="msa-time-parameters" type="submit">{{'basic.save' | translate }}</button>
                            <button type="button" class="btn btn-secondary ml-1" (click)="disableTimeEditor()">{{'basic.cancel' | translate }}</button>
                          </div>
                        </div>
                      </div>
                      <!-- Display default group sizes  -->
                      @if (defaultGroupSizes) {
                        <div [hidden]="msaEditor">
                          <div class="estimate-holder mt-10">
                            @for (item of sortByType(defaultGroupSizes); track $index; let i = $index) {
                              <div class="estimates row">
                                @if (i > 0 && item.type !== sortByType(defaultGroupSizes)[i - 1].type) {
                                  <div>
                                    <hr>
                                    </div>
                                  }
                                  <div class="col-md-6">
                                    <div>
                                      <span>{{ item.definition }}</span>
                                      <span class="mx-1">-</span>
                                      @if (customerId === 2 && item.type === 1) {
                                        <span class="blue-text">String</span>
                                      }
                                      @if (customerId !== 2 && item.type === 1) {
                                        <span class="blue-text">{{'planner.projectDashboard.frame' | translate}}</span>
                                      }
                                      @if (item.type === 2) {
                                        <span class="blue-text">{{'planner.projectDashboard.inverter' | translate}}</span>
                                      }
                                      @if (item.type === 3) {
                                        <span class="blue-text">Checkup</span>
                                      }
                                      @if (item.type === 4) {
                                        <span class="blue-text">Powerline</span>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-6 minutes">
                                    <div>
                                      {{ item.estimate }} {{'basic.installers' | translate }}
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        <!-- Edit MSA time estimates -->
                        @if (defaultGroupSizes) {
                          <div [hidden]="!msaEditor">
                            <form ngNativeValidate id="msa-time-parameters" class="estimate-holder" #f="ngForm" (ngSubmit)="saveChangesToDefaultGroupSizes(f)">
                              <div class="mt-10">
                                <div class="row">
                                  <div class="form-group col-md-6">
                                    <label>{{'basic.options' | translate }}</label>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label>Default Group size</label>
                                  </div>
                                </div>
                                @for (item of sortByType(defaultGroupSizes); track $index; let i = $index) {
                                  <div class="row">
                                    @if (i > 0 && item.type !== sortByType(defaultGroupSizes)[i - 1].type) {
                                      <div>
                                        <hr>
                                        </div>
                                      }
                                      <div class="col-md-6">
                                        <div class="form-group d-flex align-items-center h-100">
                                          <div>
                                            <span>{{ item.definition }}</span>
                                            <span class="mx-1">-</span>
                                            @if (customerId === 2 && item.type === 1) {
                                              <span class="blue-text">String</span>
                                            }
                                            @if (customerId !== 2 && item.type === 1) {
                                              <span class="blue-text">{{'planner.projectDashboard.frame' | translate}}</span>
                                            }
                                            @if (item.type === 2) {
                                              <span class="blue-text">{{'planner.projectDashboard.inverter' | translate}}</span>
                                            }
                                            @if (item.type === 3) {
                                              <span class="blue-text">Checkup</span>
                                            }
                                            @if (item.type === 4) {
                                              <span class="blue-text">Powerline</span>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 minutes">
                                        <div class="form-group">
                                          <input type="number" [(ngModel)]="item.estimate" min="1" placeholder="1" name="{{ 'estimate_'+item.id }}" class="form-control">
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </form>
                            </div>
                          }
                          <!-- <div [hidden]="msaEstimatesLoading" *ngIf="msaNames?.length > 0 && selectedMsa?.length < 1" class="gray-text mt-10">
                          {{'planner.projectPage.noEstimatesMsa' | translate }}
                        </div> -->
                        <!-- <div [hidden]="!msaEstimatesLoading" class="gray-text mt-10">
                        <load-spinner></load-spinner>
                      </div> -->
                      <!-- <div *ngIf="!msaEstimatesLoading && msaNames?.length < 1" class="gray-text mt-10">
                      {{'planner.projectPage.noMsa' | translate }}
                    </div> -->
                  </div>
                </div>
                <hr>
                </div>
              }

              @if (customerId === 3) {
                <!-- Powerline reports export -->
                <div id="powerline-reports-export" class="pb-10">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <h4>{{ 'planner.projectPage.reportsExport' | translate }}</h4>
                        <div class="gray-text">{{ 'planner.projectPage.reportsExportInfo' | translate }}</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <button type="button" class="btn btn-primary float-end" [disabled]="reportsExportLoading" (click)="downloadPowerlineReports()">
                        {{ 'planner.projectPage.downloadExcel' | translate }}
                      </button>
                      <load-spinner [hidden]="!reportsExportLoading" class="float-end mr-10"></load-spinner>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
